import { createAction } from '@reduxjs/toolkit'

import { TColorSchemeResponse } from 'types/GlobalCustomization'

// tryUpdateColorScheme
export const update = createAction('update_color_scheme')
export const updateSuccess = createAction<{ data: TColorSchemeResponse }>(
  'update_color_scheme_success'
)
export const updateFailed = createAction('update_color_scheme_failed')
